function showNotification(msg){
  var n=document.createElement("div");
  n.style.cssText="position:fixed;bottom:24px;right:24px;background:#D4AF37;color:#0A0A0A;padding:14px 24px;border-radius:6px;font-family:Montserrat,sans-serif;font-size:13px;font-weight:600;z-index:9999;transform:translateY(20px);opacity:0;transition:all .3s ease;letter-spacing:1px";
  n.textContent=msg;document.body.appendChild(n);
  requestAnimationFrame(function(){n.style.transform="translateY(0)";n.style.opacity="1"});
  setTimeout(function(){n.style.transform="translateY(20px)";n.style.opacity="0";setTimeout(function(){n.remove()},300)},2500);
}
function setCartCount(count){
  var badge=document.querySelector(".cart-badge");
  if(!badge)return;
  badge.textContent=count;badge.style.transform="scale(1.4)";
  setTimeout(function(){badge.style.transform="scale(1)"},200);
}
document.addEventListener("click",function(e){
  var btn=e.target.closest("[data-add-to-cart]");
  if(!btn)return;
  e.preventDefault();
  var id=btn.getAttribute("data-variant-id");
  fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
    .then(function(r){if(!r.ok)throw new Error();return r.json()})
    .then(function(){return fetch("/cart.js").then(function(r){return r.json()})})
    .then(function(cart){setCartCount(cart.item_count);showNotification("Added to cart!")})
    .catch(function(){showNotification("Couldn't add to cart")});
});
var mm=document.getElementById("mobileMenuBtn");
if(mm)mm.addEventListener("click",function(){
  var nl=document.getElementById("navLinks");if(nl)nl.classList.toggle("active");this.classList.toggle("active");
});
function observeElements(){
  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add("visible");observer.unobserve(entry.target)}});
  },{threshold:0.1});
  document.querySelectorAll(".fade-in:not(.visible)").forEach(function(el){observer.observe(el)});
}
function createParticles(){
  var c=document.getElementById("heroParticles");if(!c)return;
  for(var i=0;i<30;i++){
    var p=document.createElement("div");p.className="particle";
    p.style.left=Math.random()*100+"%";p.style.top=Math.random()*100+"%";
    p.style.animationDelay=Math.random()*4+"s";p.style.animationDuration=(3+Math.random()*3)+"s";
    c.appendChild(p);
  }
}
window.addEventListener("scroll",function(){
  var nav=document.getElementById("mainNav");
  if(nav)nav.style.background=window.scrollY>50?"rgba(10,10,10,0.98)":"rgba(10,10,10,0.92)";
});
document.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener("click",function(e){
    var h=this.getAttribute("href");
    if(h&&h.length>1){var t=document.querySelector(h);if(t){e.preventDefault();t.scrollIntoView({behavior:"smooth"})}}
    var nl=document.getElementById("navLinks");if(nl)nl.classList.remove("active");
  });
});
if(location.search.indexOf("customer_posted=true")>-1)document.addEventListener("DOMContentLoaded",function(){showNotification("Welcome to the Inner Circle! 💎")});
document.addEventListener("DOMContentLoaded",function(){
  createParticles();
  document.querySelectorAll(".category-card,.comparison-card,.review-card,.about-content,.split-cta-left,.split-cta-right,.newsletter-inner,.product-card").forEach(function(el){el.classList.add("fade-in")});
  observeElements();
});

// ===== Product page =====
document.addEventListener("click",function(e){
  var a=e.target.closest("[data-slide]");
  if(a){var g=a.closest("[data-gallery]"),s=g.querySelectorAll(".pp-slide"),t=g.querySelectorAll(".pp-thumb"),i=[].findIndex.call(s,function(x){return x.classList.contains("active")});
    var n=(i+Number(a.dataset.slide)+s.length)%s.length;
    s.forEach(function(x,k){x.classList.toggle("active",k===n)});t.forEach(function(x,k){x.classList.toggle("active",k===n)});}
  var th=e.target.closest("[data-thumb]");
  if(th){var g2=th.closest("[data-gallery]"),n2=Number(th.dataset.thumb);
    g2.querySelectorAll(".pp-slide").forEach(function(x,k){x.classList.toggle("active",k===n2)});
    g2.querySelectorAll(".pp-thumb").forEach(function(x,k){x.classList.toggle("active",k===n2)});}
  var sc=e.target.closest("[data-scroll]");
  if(sc){var tr=sc.parentElement.querySelector(".pp-track");tr.scrollBy({left:Number(sc.dataset.scroll)*tr.clientWidth*0.8,behavior:"smooth"});}
});
document.addEventListener("change",function(e){
  var r=e.target.closest(".pp-pill input");if(!r)return;
  var p=document.getElementById("ppPrice"),c=document.getElementById("ppCompare");
  if(p)p.textContent=r.dataset.price;if(c)c.textContent=r.dataset.compare||"";
  var sv=document.getElementById("ppSave");if(sv&&!r.dataset.compare)sv.style.display="none";
});
// AJAX add-to-cart for the product form (also used by the sticky bar)
document.addEventListener("submit",function(e){
  var f=e.target.closest(".pp-form");if(!f||e.target!==f)return;   /* ignore nested app forms (e.g. Hulk) */
  if(e.submitter&&e.submitter.closest&&e.submitter.closest(".pxFormGenerator"))return;   /* Hulk's own submit button is not an add-to-cart */
  e.preventDefault();
  fetch("/cart/add.js",{method:"POST",headers:{"Accept":"application/json"},body:new FormData(f)})   /* sends id, quantity AND properties[...] */
    .then(function(r){if(!r.ok)throw new Error();return r.json()})
    .then(function(){return fetch("/cart.js").then(function(r){return r.json()})})
    .then(function(cart){setCartCount(cart.item_count);showNotification("Added to cart!")})
    .catch(function(){showNotification("Couldn't add to cart")});
});
// Sticky bar appears once the main button scrolls out of view
document.addEventListener("DOMContentLoaded",function(){
  var atc=document.querySelector(".pp-atc"),bar=document.getElementById("ppSticky");
  if(atc&&bar&&"IntersectionObserver" in window){new IntersectionObserver(function(en){bar.classList.toggle("show",!en[0].isIntersecting&&en[0].boundingClientRect.top<0)}).observe(atc)}
});

// ===== Multi-level navigation: tap-to-expand on touch / small screens, hover on desktop =====
(function(){
  var nav=document.getElementById("navLinks");if(!nav)return;
  var menuBtn=document.getElementById("mobileMenuBtn");
  var touchMode=window.matchMedia("(max-width: 768px), (hover: none)");
  function setOpen(li,open){
    li.classList.toggle("open",open);
    var l=li.querySelector(":scope > .nav-link"),b=li.querySelector(":scope > .nav-toggle");
    if(l)l.setAttribute("aria-expanded",open);if(b)b.setAttribute("aria-expanded",open);
  }
  function closeAll(except){nav.querySelectorAll(".has-sub.open").forEach(function(li){if(li!==except)setOpen(li,false)})}
  nav.addEventListener("click",function(e){
    var trigger=e.target.closest(".has-sub > .nav-link, .has-sub > .nav-toggle");
    if(trigger){
      if(!touchMode.matches)return;           /* desktop mouse: parent links navigate, hover opens the menu */
      e.preventDefault();                      /* touch: first tap expands; "All ..." link inside navigates */
      var li=trigger.parentElement,willOpen=!li.classList.contains("open");
      closeAll(willOpen?li:null);setOpen(li,willOpen);return;
    }
    if(e.target.closest("a")){                 /* a real link was tapped: reset menus and close the mobile panel */
      closeAll();nav.classList.remove("active");if(menuBtn)menuBtn.classList.remove("active");
    }
  });
  document.addEventListener("click",function(e){if(!e.target.closest("#navLinks")&&!e.target.closest("#mobileMenuBtn"))closeAll()});
  document.addEventListener("keydown",function(e){
    if(e.key!=="Escape")return;
    var open=nav.querySelector(".has-sub.open > .nav-link");closeAll();
    if(open&&touchMode.matches)open.focus();
  });
  if(menuBtn)menuBtn.addEventListener("click",function(){if(!nav.classList.contains("active"))closeAll()});
  var onChange=function(){closeAll();nav.classList.remove("active");if(menuBtn)menuBtn.classList.remove("active")};
  if(touchMode.addEventListener)touchMode.addEventListener("change",onChange);else if(touchMode.addListener)touchMode.addListener(onChange);
})();

// ===== Custom quote mode: variant "Add Custom Modifications" -> "REQUEST A CUSTOM QUOTE" =====
(function(){
  var QUOTE_MATCH="custom modification",QUOTE_LABEL="REQUEST A CUSTOM QUOTE";
  function selectedVariantTitle(form){
    var checked=form.querySelector('input[name="id"]:checked');
    if(checked){var span=checked.nextElementSibling;return span?span.textContent:"";}
    var sel=form.querySelector('select[name="id"]');
    if(sel&&sel.selectedIndex>-1)return sel.options[sel.selectedIndex].text;
    return "";
  }
  function setLabel(btn,text,instant){
    if(!btn||btn.disabled||btn.textContent.trim()===text)return;
    if(instant){btn.textContent=text;return;}
    btn.classList.add("is-swapping");
    setTimeout(function(){btn.textContent=text;btn.classList.remove("is-swapping")},150);
  }
  function update(form,instant){
    var isQuote=selectedVariantTitle(form).toLowerCase().indexOf(QUOTE_MATCH)>-1;
    var main=form.querySelector(".pp-atc"),sticky=document.querySelector(".pp-sticky-atc");
    [main,sticky].forEach(function(btn){
      if(!btn)return;
      if(!btn.getAttribute("data-default-label"))btn.setAttribute("data-default-label",btn.textContent.trim());
      setLabel(btn,isQuote?QUOTE_LABEL:btn.getAttribute("data-default-label"),instant);
      btn.classList.toggle("is-quote-mode",isQuote);
    });
    form.setAttribute("data-quote-mode",isQuote?"true":"false");
    /* hook for a pop-up or form: document.addEventListener("centuria:quote-mode", ...) */
    document.dispatchEvent(new CustomEvent("centuria:quote-mode",{detail:{active:isQuote,form:form}}));
  }
  document.addEventListener("change",function(e){
    var f=e.target.closest&&e.target.closest(".pp-form");
    if(f&&e.target.name==="id")update(f,false);
  });
  document.addEventListener("DOMContentLoaded",function(){
    var f=document.querySelector(".pp-form");if(f)update(f,true);
  });
})();
